import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { EmployerProfile } from '@factoryfixinc/ats-interfaces';

export const useEmployerProfileStore = defineStore(
  'employerProfile',
  () => {
    const employerProfile = ref<EmployerProfile | undefined>(undefined);

    function clear() {
      employerProfile.value = undefined;
    }

    // alphabetized list
    return {
      clear,
      employerProfile,
    };
  },
  {
    persist: true,
  },
);
